module.exports = {
	"failed": "Login failed",
	"success": "Login successful",
	"username": "Username",
	"password": "Password",
	"login": "Login",
	"recaptchaRequired": "Please complete the reCAPTCHA check.",
	"recaptchaLoadFailed": "Unable to load reCAPTCHA. Please refresh and try again.",
	"recaptchaError": "reCAPTCHA verification failed. Please try again."
};


//////////////////
// WEBPACK FOOTER
// ./src/locale/en/auth.json
// module id = 833
// module chunks = 1